import { render, staticRenderFns } from "./MemberBenefit.vue?vue&type=template&id=de8f9e2a&scoped=true"
import script from "./MemberBenefit.vue?vue&type=script&lang=js"
export * from "./MemberBenefit.vue?vue&type=script&lang=js"
import style0 from "./MemberBenefit.vue?vue&type=style&index=0&id=de8f9e2a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "de8f9e2a",
  null
  
)

export default component.exports